'use client';

import { useState } from 'react';
import { TurnstileWidget } from '@/features/cloudflare/components/TurnstileWidget';
import { Dialog, DialogContent } from '@/shadcn/components/ui/dialog';
import { revealListingPhone } from '@/api/generated/portal-listings';
import { formatPhoneNumber } from '@/features/adverts/utils';

export function ListingPhoneReveal(props: { listingId: string; phoneHint: string }) {
    // State
    const [display, setDisplay] = useState(false);
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');

    async function request(token: string) {
        try {
            //
            const res = await revealListingPhone(
                { listingId: props.listingId, turnstileToken: token },
                { portalApiKey: true },
            );
            if (res.phone) {
                setPhone(res.phone);
            }
            setDisplay(false);
        } catch (e) {
            setError('Pri načítaní nastala chyba, Skúste to neskôr.');
        }
    }

    return (
        <>
            {!error ? (
                <>
                    {!phone && (
                        <>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setDisplay(true);
                                }}
                            >
                                {props.phoneHint} <span style={{ fontSize: '80%' }}>Zobraziť</span>
                            </a>
                        </>
                    )}
                    {display && (
                        <Dialog open={true}>
                            <DialogContent>
                                <TurnstileWidget
                                    onVerify={(t) => {
                                        request(t);
                                    }}
                                />
                            </DialogContent>
                        </Dialog>
                    )}
                    {phone && (
                        <a
                            href={`tel:${formatPhoneNumber(phone).replaceAll(' ', '')}`}
                            onClick={(e) => e.preventDefault()}
                        >
                            {formatPhoneNumber(phone)}
                        </a>
                    )}
                </>
            ) : (
                <>
                    <p style={{ fontSize: '12px', lineHeight: '130%' }}>{error}</p>
                </>
            )}
        </>
    );
}
